import { FC } from 'react';
import MintCertificateForm from '../components/MintCertificateForm';
import './CertificateIssuancePage.css';
import { useTranslation } from 'react-i18next';


interface TemplateData {
    name: string;
    description: string;
    categories: string[];
    rawMaterials: { value: string; label: string }[];
    vintageYear: string;
    imageUrl?: string;
    latitude?: number;
    longitude?: number;
}

interface CertificateIssuancePageProps {
    onCertificateMinted: (tokenId: string) => void;
    onBack: () => void;
    templateData?: TemplateData | null;
}

const CertificateIssuancePage: FC<CertificateIssuancePageProps> = ({ onCertificateMinted, onBack, templateData }) => {
    const { t } = useTranslation();

    return (
        <div className="issuance-page-container">
            <button onClick={onBack} className="back-button action-button" style={{ width: 'auto', margin: '0 0 20px 0', display: 'inline-block' }}>
                {t('backToSearch')}
            </button>
            <p>{t('issueNewCertificateSubtitle')}</p>
            <MintCertificateForm onMinted={onCertificateMinted} templateData={templateData} />
        </div>
    );
};

export default CertificateIssuancePage;